import SectionMessage from '@atlaskit/section-message/message';
import FullScreenModalTriggerExample from "../../../../../../packages/design-system/entry-points/examples/constellation/full-screen-modal-trigger";
import RAW_UNSAFEUPUPSLASHUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHfull_screen_modal_trigger from "!!raw-loader!../../../../../../packages/design-system/entry-points/examples/constellation/full-screen-modal-trigger";
import * as React from 'react';
export default {
  SectionMessage,
  FullScreenModalTriggerExample,
  RAW_UNSAFEUPUPSLASHUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHfull_screen_modal_trigger,
  React
};